import script from "./exam.vue?vue&type=script&setup=true&lang=js"
export * from "./exam.vue?vue&type=script&setup=true&lang=js"

import "./exam.vue?vue&type=style&index=0&id=9c5748f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c5748f2"]])

export default __exports__